module.exports = __webpack_public_path__ + "static/media/insorb-logo-pwa@3x.e969da69.jpg";